module.exports = __webpack_public_path__ + "img/sban4.ae30d98f.jpg";